const missionControl = {
  header: {
    title: 'Mission Control',
    createScenario: 'BUILD A NEW SCENARIO',
  },

  cards: {
    titles: {
      co2Savings: 'CO2 Savings',
      onTimePerfformance: 'On-Time Perforamnce',
      vehicleEfficiency: 'Vehicle Efficiency',
      passengerSatisfaction: 'Passenger Satisfaction',
      costPerMile: 'Cost per Mile',
    },
  },

  layers: {
    title: 'Map Layer',

    titles: {
      visibility: 'Visibility',
      layerDate: 'Layer Data',
      visualRepresenatation: 'Visual Representation',
    },

    filters: {
      status: {
        title: 'Status',
        placeholder: 'Status',
        options: {
          new: 'New',
          on_hold: 'On Hold',
          routing: 'Routing',
          routed: 'Routed',
          canceled: 'Canceled',
          picked: 'Picked',
          dropped: 'Dropped',
          noshow: 'Noshow',
          queued: 'Queued',
        },
      },

      zones: {
        title: 'Zone',
      },

      powerType: {
        title: 'Charging Power',
        placeholder: 'Charging Power',
        options: {
          fast: 'Fast',
          slow: 'Slow',
          turbo: 'Turbo',
        },
      },

      connectorType: {
        title: 'Connector Type',
        placeholder: 'Connector Type',
        options: {
          EC_Type_1: 'IEC Type 1',
          IEC_Type_2_J1772: 'IEC Type 2 (J1772)',
          IEC_Type_2: 'IEC Type 2',
          IEC_Type_3: 'IEC Type 3',
          CHAOJI: 'CHAOJI',
          NEMA: 'NEMA',
          TESLA: 'TESLA',
          CHADEMO: 'CHADEMO',
          GBT: 'GBT',
        },
      },
    },

    content: {
      traffic: {
        title: 'Traffic',
        description: 'Layer description explaining what we show on the map',
        mildlyhigher: 'Mildly Higher',
        trafficJam: 'Traffic Jam',
      },

      evsChargingPoints: {
        title: 'EVs Charging Points',
        description: 'Layer description explaining what we show on the map',
        chargingPointOptions: {
          fast: 'Fast Charging Point',
          slow: 'Slow Charging Point',
        },
      },

      heatMap: {
        title: 'Heat Map',
        description: 'Layer description explaining what we show nn the map',
        scaleOfDemand: 'Scale Of Demand',
      },

      dots: {
        title: 'Dots',
        description: 'Layer description explaining what we whow on the map',
        numberOfDemands: 'Number Of Demand',
      },

      tripsLiveStream: {
        title: 'Live Stream Of Trips',
        description: 'Layer description explaining what we show on the map',
        tripProgress: 'Trip Progress',
        pickUp: 'Pick Up',
        dropOff: 'Drop Off',
      },
    },
  },

  kpis: {
    title: 'KPIs',

    titles: {
      driversAndVehicles: 'Drivers & Vehicles',
      routes: 'Routes',
    },
  },
};

export default missionControl;
